import {
  categoryStructure as defaultCategoryStructure,
  type CategoryStructure,
} from "@/lib/categoryStructure";
import { activeSubcategoryIdSet } from "@/lib/activeCategories";

export type InactiveCategoryGroup = {
  categoryName: string;
  subcategoryNames: string[];
};

export const INACTIVE_CATEGORY_PREVIEW_ROW_LIMIT = 3;

export function getInactiveSubcategoriesByCategory(
  activeCategoryStructure: CategoryStructure[],
  fullStructure: CategoryStructure[] = defaultCategoryStructure,
): InactiveCategoryGroup[] {
  const activeIds = activeSubcategoryIdSet(activeCategoryStructure);

  return fullStructure
    .map((c) => ({
      categoryName: c.name,
      subcategoryNames: c.subcategories
        .filter((s) => !activeIds.has(s.id))
        .map((s) => s.name)
        .sort((a, b) => a.localeCompare(b)),
    }))
    .filter((c) => c.subcategoryNames.length > 0);
}

export function getInactiveCategoryPreview(
  groups: InactiveCategoryGroup[],
  rowLimit: number = INACTIVE_CATEGORY_PREVIEW_ROW_LIMIT,
): {
  previewRows: InactiveCategoryGroup[];
  hiddenCategoryCount: number;
} {
  if (groups.length <= rowLimit) {
    return { previewRows: groups, hiddenCategoryCount: 0 };
  }
  return {
    previewRows: groups.slice(0, rowLimit),
    hiddenCategoryCount: groups.length - rowLimit,
  };
}
